// extracted by mini-css-extract-plugin
export default {"projectImage":"Projects_projectImage__3Qnle"};